var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38 19C38 8.507 29.494 0 19 0 8.507 0 0 8.507 0 19h4.137c0-8.208 6.654-14.863 14.863-14.863S33.863 10.791 33.863 19H38z"}));
}

Spinner.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38"};

module.exports = Spinner;

Spinner.default = Spinner;
